import {ChangeDetectionStrategy, Component, ViewContainerRef} from '@angular/core';
import {ModalService} from './modal.service';

@Component({
    selector: 'modal-anchor',
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalAnchorComponent {

    constructor(
        private viewContainerRef: ViewContainerRef,
        private modal: ModalService
    ) {
        this.modal.setDefaultViewContainerRef(this.viewContainerRef);
    }

}
